import { c as _c } from "react/compiler-runtime";
import React from "react";
import { ApiWave } from "@/generated/models/ApiWave";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import { ApiWaveDecision } from "@/generated/models/ApiWaveDecision";
import { WaveWinnersEmpty } from "./WaveWinnersEmpty";
import { format } from "date-fns";
import { WaveWinnersTimelineLoading } from "./WaveWinnersTimelineLoading";
import { WaveWinnersDrops } from "./drops/WaveWinnersDrops";
interface WaveWinnersTimelineProps {
  readonly onDropClick: (drop: ExtendedDrop) => void;
  readonly decisionPoints: ApiWaveDecision[];
  readonly wave: ApiWave;
  readonly isLoading: boolean;
}
export const WaveWinnersTimeline: React.FC<WaveWinnersTimelineProps> = t0 => {
  const $ = _c(24);
  const {
    onDropClick,
    decisionPoints,
    wave,
    isLoading
  } = t0;
  const groupedByDate = {};
  [...decisionPoints].forEach(point => {
    const dateKey = format(new Date(point.decision_time), "yyyy-MM-dd");
    if (!groupedByDate[dateKey]) {
      groupedByDate[dateKey] = [];
    }
    groupedByDate[dateKey].push(point);
  });
  if (isLoading) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <WaveWinnersTimelineLoading />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    return t1;
  }
  if (decisionPoints.length === 0) {
    let t1;
    if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <WaveWinnersEmpty />;
      $[1] = t1;
    } else {
      t1 = $[1];
    }
    return t1;
  }
  const sortedDecisionPoints = [...decisionPoints].filter(_temp).sort(_temp2);
  const roundMap = new Map();
  sortedDecisionPoints.forEach((point_1, index) => {
    roundMap.set(point_1.decision_time, index + 1);
  });
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[2] !== decisionPoints || $[3] !== onDropClick || $[4] !== wave) {
    const sortedDisplayPoints = [...decisionPoints].filter(_temp3).sort(_temp4);
    t5 = "tw-pt-4 tw-overflow-y-auto tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 hover:tw-scrollbar-thumb-iron-300";
    t3 = "tw-relative";
    if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <div className="tw-absolute tw-left-2 lg:tw-left-[19px] tw-top-0 tw-bottom-0 tw-w-px tw-bg-iron-700/80" />;
      $[10] = t4;
    } else {
      t4 = $[10];
    }
    t1 = "tw-space-y-6";
    let t6;
    if ($[11] !== onDropClick || $[12] !== wave) {
      t6 = point_3 => {
        const date = new Date(point_3.decision_time);
        const formattedDate = format(date, "EEE, MMM d, yyyy");
        const formattedTime = format(date, "h:mm a");
        return <div key={`decision-${point_3.decision_time}`} className="tw-relative group"><div className="tw-absolute tw-left-0 lg:tw-left-3 tw-top-[0.3125rem] tw-z-10"><div className="tw-size-4 tw-rounded-full tw-flex tw-items-center tw-justify-center tw-bg-iron-800 tw-border tw-border-iron-700/50 tw-transition-all group-hover:tw-border-iron-500"><div className="tw-rounded-full tw-bg-iron-500 tw-size-2 tw-transition-all group-hover:tw-bg-iron-400 group-hover:tw-size-2.5" /></div></div><div className="tw-ml-6 lg:tw-ml-10 tw-mb-2 lg:tw-mb-3"><div className="tw-flex tw-flex-wrap tw-items-baseline tw-gap-x-3 tw-gap-y-1"><h3 className="tw-text-sm tw-text-iron-300 tw-font-medium tw-tracking-wide">{formattedDate}</h3><span className="tw-text-xs tw-text-iron-400 tw-font-light tw-tracking-wide">{formattedTime}</span></div></div><div className="tw-ml-6 tw-mb-6"><div className="lg:tw-px-4 lg:tw-pb-4"><WaveWinnersDrops winners={point_3.winners} onDropClick={onDropClick} wave={wave} isLoading={false} /></div></div></div>;
      };
      $[11] = onDropClick;
      $[12] = wave;
      $[13] = t6;
    } else {
      t6 = $[13];
    }
    t2 = sortedDisplayPoints.map(t6);
    $[2] = decisionPoints;
    $[3] = onDropClick;
    $[4] = wave;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t1 = $[5];
    t2 = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
  }
  let t6;
  if ($[14] !== t1 || $[15] !== t2) {
    t6 = <div className={t1}>{t2}</div>;
    $[14] = t1;
    $[15] = t2;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  let t7;
  if ($[17] !== t3 || $[18] !== t4 || $[19] !== t6) {
    t7 = <div className={t3}>{t4}{t6}</div>;
    $[17] = t3;
    $[18] = t4;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t5 || $[22] !== t7) {
    t8 = <div className={t5}>{t7}</div>;
    $[21] = t5;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  return t8;
};
function _temp(point_0) {
  return point_0.winners.length > 0;
}
function _temp2(a, b) {
  return new Date(a.decision_time).getTime() - new Date(b.decision_time).getTime();
}
function _temp3(point_2) {
  return point_2.winners.length > 0;
}
function _temp4(a_0, b_0) {
  return new Date(b_0.decision_time).getTime() - new Date(a_0.decision_time).getTime();
}